module.exports = __webpack_public_path__ + "static/media/globe.be931460.svg";